<template>
<hm-content title=''>
     <div class="table-panel flex flex-start shop-list">
      <!-- <el-input
        clearable
        v-model.trim="searchCondition.keyWords"
        placeholder="请输入货号/条码/商品名"
        size="small"
        class="ipt mr10 flex-1"
      ></el-input> -->
      <el-input
        clearable
        style="width: 300px"
        v-model.trim="searchCondition.keyWords"
        size="small"
        :placeholder="placeholder"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          @change="selectQueryType"
          v-model="searchCondition.queryType"
        >
          <el-option label="商品名" value="spu_name"></el-option>
          <el-option label="货号" value="goods_sn"></el-option>
          <el-option label="条码" value="spec_barcode"></el-option>
        </el-select>
      </el-input>
      <el-select
        filterable
        clearable
        size="small"
        class="mr10 flex-1"
        v-model="searchCondition.brandId"
        placeholder="请选择商品品牌"
      >
        <el-option
          :label="v.brandName"
          :value="v.brandId"
          v-for="(v, i) in allBrandList"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        filterable
        clearable
        size="small"
        class="mr10 flex-1"
        v-model="searchCondition.spuType"
        placeholder="请选择商品类型"
      >
        <el-option label="实物" value="reality"></el-option>
        <el-option label="虚拟" value="virtual"></el-option>
      </el-select>
      <el-select
        filterable
        clearable
        size="small"
        class="mr10 flex-1"
        v-model="searchCondition.overstockSales"
        placeholder="请选择是否开启预售"
      >
        <el-option label="已开启" value="open"></el-option>
        <el-option label="未开启" value="close"></el-option>
      </el-select>
      <el-select
        filterable
        clearable
        size="small"
        class="mr10 flex-1"
        v-model="searchCondition.spuMainPic"
        placeholder="请选择是否有主图"
      >
        <el-option label="有主图" value="yes"></el-option>
        <el-option label="无主图" value="no"></el-option>
      </el-select>
      <el-cascader
        v-model="searchCondition.categoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryFuncs"
        clearable
        placeholder="请选择类目"
      ></el-cascader>

      <el-cascader
        v-model="searchCondition.wxshopCategoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryProp"
        clearable
        placeholder="请选择微店商品分类"
      ></el-cascader>
    </div>
    <div class="flex flex-start mb10">
      <el-cascader
        v-model="searchCondition.attributeId"
        placeholder="请选择辅助属性"
        :show-all-levels="false"
        size="small"
        class="mr10"
        :props="attributeFunc"
        clearable
      ></el-cascader>
      <el-select
        size="small"
        clearable
        placeholder="上架状态"
        v-model="searchCondition.salesState"
        class="mr10"
        filterable
      >
        <el-option label="上架" value="up"></el-option>
        <el-option label="下架" value="down"></el-option>
      </el-select>
      <el-input
        clearable
        style="width: 100px"
        v-model.trim="searchCondition.minPrice"
        placeholder="最低零售价"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        style="width: 100px"
        v-model.trim="searchCondition.maxPrice"
        placeholder="最高零售价"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择创建时间段"
        end-placeholder="请选择创建时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class=" mr10 time"
      ></el-date-picker>
      <el-select
        size="small"
        v-model="searchCondition.expressId"
        filterable
        class="mr10"
        clearable
        placeholder="请选择运费模板"
      >
        <el-option
          :label="v.expressName"
          :value="v.expressId"
          v-for="(v, i) in expressList"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
          filterable
          clearable
          size="small"
          class="mr10"
          v-model="searchCondition.goodsState"
          placeholder="请选择商品状态"
      >
        <el-option label="隐藏" value="hide"></el-option>
        <el-option label="删除" value="del"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search">查询</el-button>

    </div>
<div class='table'>
     <el-table
        stripe
        border
        ref="goodsTable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
              <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
          <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="商品名称"
        >
          </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="商品品牌"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuType"
          label="商品类型"
        >
          <template slot-scope="scope">
            <el-tag type="warning"
              >{{
                scope.row.spuType === "virtual" ? "虚拟" : "实物"
              }}商品</el-tag
            >

          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="overstockSales"
          label="是否开启预售"
        >
          <template slot-scope="scope">
            <span v-show="scope.row.overstockSales === 'open'">已开启</span>
            <span v-show="scope.row.overstockSales === 'close'">未开启</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuMainPic"
          label="是否有主图"
          width="120px"
        >
          <template slot-scope="scope">
            <el-image
              style="width:100px; height:100px"
              :src="scope.row.spuMainPic"
              :preview-src-list="[scope.row.spuMainPic]"
              v-if="scope.row.spuMainPic"
            >
            </el-image>
            <span v-else>无主图</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="可售门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realSalesNum"
          label="销量"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="supplierName"
          label="供货商"
        >
          <template slot-scope="scope">
            {{
              scope.row.supplierName === null ? "自营" : scope.row.supplierName
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="上架状态"
        >
          <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.salesState === 0"
              >下架</span
            >
            <span class="status success" v-show="scope.row.salesState === 1"
              >上架</span
            >
          </template>
        </el-table-column>
       <el-table-column
           header-align="center"
           align="center"
           prop="goodsState"
           label="商品状态"
       >
         <template slot-scope="scope">
            <span class="status danger" v-show="scope.row.goodsState === 'del'"
            >删除</span
            >
           <span class="status success" v-show="scope.row.goodsState === 'hide'"
           >隐藏</span
           >
         </template>
       </el-table-column>
        <!-- <el-table-column header-align="center" align="center" label="库存">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewStock(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          width="200"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
                 <el-button
                type="text"
                size="small"
                @click="reduction(scope.row)"
              >
                还原
              </el-button>
            </div>
          </template>
        </el-table-column>
     </el-table>
            <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
</div>

</hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      allBrandList: [],
      expressList: [],
      placeholder: "请输入商品名",
      searchCondition: {
        queryType: "spu_name",
        goodsState: "",
      },
      list: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      stockDialogVisible: false,
      categoryFuncs: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      categoryProp: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.wxshopCategoryId) {
      this.searchCondition.wxshopCategoryId = this.$route.query.wxshopCategoryId;
    }
    this.queryExpressList();
    this.queryBrandAllList();
    this.queryList();
  },
  methods: {
    async reduction(row) {
      const { code } = await this.$store.dispatch("recycle", {
        wxshopSpuId: row.wxshopSpuId
      });
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryList();
      }
    },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryBrandAllList() {
      const { result } = await this.$store.dispatch("queryBrandAllList", {
        pageSize: 999999,
        pageNo: 1
      });
      this.allBrandList = result.records;
    },
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      searchCondition.createStartTime = this.isArray(
        this.searchCondition.applyDate
      )
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.createEndTime = this.isArray(
        this.searchCondition.applyDate
      )
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      // if (!this.$route.query.wxshopCategoryId) {
      //   this.setParamsCookie();
      // }

      const { result } = await this.$store.dispatch("queryRecycleList", params);
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async viewStock(row) {
      this.stockDialogVisible = true;
      const { result } = await this.$store.dispatch("queryStockSkuList", {
        spuId: row.spuId
      });
      let list = [];
      result.map(v => {
        if (v.depotStockList.length) {
          v.depotStockList.map(o => {
            list.push({
              spuName: v.spuName,
              ...o
            });
          });
        } else {
          list.push(v);
        }
      });
      this.stockList = list;
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
